"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));
var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");
var _theme = _interopRequireDefault(require("./theme"));
var _FormPropTypes = _interopRequireDefault(require("../../utils/FormPropTypes"));
var _FormFieldMessage = _interopRequireDefault(require("../FormFieldMessage"));
var _dec, _class, _class2, _temp;
var styles = {
  componentId: 'fAfJj',
  template: function template(theme) {
    return "\n\n.fAfJj_bGBk{margin:calc(-1*".concat(theme.topMargin || 'inherit', ") 0 0 0;padding:0}\n\n.fAfJj_elxg,.fAfJj_bGBk{display:block}");
  },
  'root': 'fAfJj_bGBk',
  'message': 'fAfJj_elxg'
};
var FormFieldMessages = (
/**
---
parent: FormField
---

A FormFieldMessages component

```js
---
example: true
---
<FormFieldMessages messages={[
  { text: 'Invalid name', type: 'error' },
  { text: 'Good job!', type: 'success' },
  { text: 'Full name, first and last', type: 'hint' },
]} />
```
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldMessages, _Component);
  function FormFieldMessages() {
    (0, _classCallCheck2.default)(this, FormFieldMessages);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldMessages).apply(this, arguments));
  }
  (0, _createClass2.default)(FormFieldMessages, [{
    key: "render",
    value: function render() {
      var messages = this.props.messages;
      return messages && messages.length > 0 ? _react.default.createElement("span", Object.assign({
        className: styles.root
      }, (0, _passthroughProps.omitProps)(this.props, FormFieldMessages.propTypes)), messages.map(function (msg, i) {
        return _react.default.createElement("span", {
          key: "error".concat(i),
          className: styles.message
        }, _react.default.createElement(_FormFieldMessage.default, {
          variant: msg.type
        }, msg.text));
      })) : null;
    }
  }]);
  FormFieldMessages.displayName = "FormFieldMessages";
  return FormFieldMessages;
}(_react.Component), _class2.propTypes = {
  /**
  * object with shape: `{
  * text: PropTypes.string,
  * type: PropTypes.oneOf(['error', 'hint', 'success', 'screenreader-only'])
  *   }`
  */
  messages: _propTypes.default.arrayOf(_FormPropTypes.default.message)
}, _class2.defaultProps = {
  messages: void 0
}, _temp)) || _class);
exports.default = FormFieldMessages;